import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Warning — attention states (agreement expiring, conflicts). */
export function WarningIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M12 4.2 21 19.5H3L12 4.2Z" />
      <path d="M12 10v4.4" />
      <path d="M12 17h.01" />
    </PortalIcon>
  );
}
